module.exports = __webpack_public_path__ + "static/hero-050d6be98e35a40e61fdc88c564c2bd6.jpg";